import React from 'react';
import noop from 'mn-utils/noop';

import './styles.scss';

import withState from '../../../../../utils/withState';
import inputCtor from '../../utils/inputCtor';
import HelperText from '../HelperText';
import LabelDisplay from '../LabelDisplay';

const InputsDisplay = withState((setState, self) => {
  const arrayOfFields = new Array(self.props.codeLength || 1).fill('');
  return (state, props) => {
    const {
      name,
      value = '',
      onChange = noop,
      disabled
    } = props;

    const arrayOfValues = value.split('');

    return (
      <div className="code-field__inputs-row">
        {arrayOfFields.map((el, i) => (
          <div className="code-field__input-wrapper">
            <input
              key={i}
              className="code-field__input"
              value={arrayOfValues[i] || ''}
              onFocus={() => {
                const codeFieldsArr = document.getElementsByClassName('code-field__input');
                const prevField = codeFieldsArr[i - 1];
                if (prevField && !prevField.value) prevField.focus();
              }}
              onKeyDown={(e) => {
                const key = e.key;

                if (key !== 'Backspace' && isNaN(key)) return;

                let nextFieldIndex = i;

                if (key === 'Backspace') {
                  if (arrayOfValues[i]) {
                    arrayOfValues[i] = '';
                  } else {
                    arrayOfValues[i - 1] = '';
                    nextFieldIndex = i - 1;
                  }
                } else if (!isNaN(key)) {
                  arrayOfValues[i] = key;
                  nextFieldIndex = i + 1;
                }

                onChange(name, arrayOfValues.join(''));

                setTimeout(() => {
                  const codeFieldsArr = document.getElementsByClassName('code-field__input');
                  const nextField = codeFieldsArr[nextFieldIndex];

                  if (nextField) nextField.focus();
                });
              }}
              disabled={disabled}
            />
          </div>
        ))}
      </div>
    );
  }
})

const Component = ({
  className,
  labelProps= {},
  inputProps = {},
  errorProps = {},
  codeLength
}) => {
  return (
    <div
      id={inputProps.id}
      className={[
        'code-field',
        inputProps.disabled ? ' disabled' : '',
        errorProps.showError ? ' error' : '',
        className
      ].join(' ')}
    >
      <LabelDisplay {...labelProps} />
      <InputsDisplay {...inputProps} codeLength={codeLength} />
      <HelperText {...errorProps} />
    </div>
  );
};

export default inputCtor(Component)
